import {
  Declaration,
  DeclarationCustomsFlowType,
  DeclarationCustomsType,
  DeclarationHighValueGroupType,
  DeclarationStatus,
  EnvironmentCountries,
} from '@e-origin/shared';

const isHighValueGroup = (group?: string): boolean =>
  group ? Object.values(DeclarationHighValueGroupType).includes(group as DeclarationHighValueGroupType) : false;

const canRequestInvalidationForNL = (declarationDetails: Declaration): boolean => {
  if (declarationDetails.generalInfo.isExport) {
    return [DeclarationStatus.RELEASED, DeclarationStatus.ACCEPTED].includes(declarationDetails.generalInfo.status);
  }

  if (isHighValueGroup(declarationDetails.generalInfo.group)) {
    return declarationDetails.customsState?.flow === DeclarationCustomsFlowType.POST && declarationDetails.generalInfo.status === DeclarationStatus.ACCEPTED;
  }

  return declarationDetails.generalInfo.status === DeclarationStatus.ACCEPTED;
};

export const canDisplayRequestInvalidationButton = (declarationDetails: Declaration, configCountry: EnvironmentCountries): boolean => {
  if (declarationDetails.customsState?.invalidationRequest?.invalidationRequestDate) {
    return false;
  }

  if (declarationDetails.generalInfo.status === DeclarationStatus.RELEASED) return true;

  if (configCountry === EnvironmentCountries.NL) {
    return canRequestInvalidationForNL(declarationDetails);
  }

  if (isHighValueGroup(declarationDetails.generalInfo.group)) {
    return [DeclarationStatus.RELEASED, DeclarationStatus.ACCEPTED].includes(declarationDetails.generalInfo.status);
  }

  return false;
};

const isPreAcceptedImportDeclaration = (declarationDetails: Declaration): boolean =>
  !declarationDetails.generalInfo?.isExport &&
  declarationDetails.generalInfo?.status === DeclarationStatus.ACCEPTED &&
  declarationDetails.customsState?.flow === DeclarationCustomsFlowType.PRE &&
  [DeclarationCustomsType.DMS, DeclarationCustomsType.NL_AES].includes(declarationDetails.customsState?.sentTo);

export const canDisplayInvalidationSection = (declarationDetails: Declaration): boolean =>
  [DeclarationStatus.RELEASED, DeclarationStatus.ACCEPTED].includes(declarationDetails.generalInfo?.status) &&
  !isPreAcceptedImportDeclaration(declarationDetails);
